<div class="headline-container">
  <span class="headline">
    {{ 'home.webcharges.overview.title' | translate }}
    <span *ngIf="(webcharges$ | async) as w">
      ({{ w.totalElements }})
    </span>
  </span>
  <div class="controls">
    <select class="select" (change)="onPreorderStatusChange($event.target.value)">
      <option [value]="''" [selected]="webchargeStatus === null">{{ 'home.webcharges.overview.status' | translate }}</option>
      <option *ngFor="let e of webchargeStatusEnum" [value]="e" [selected]="webchargeStatus === e">{{ 'home.webcharges.overview.table.status.' + e | translate }}</option>
    </select>
    <input type="text" class="input small-input"
           [placeholder]="'home.webcharges.overview.search-reference' | translate"
           (input)="onReferenceFilterChange($event.target.value)"
    >
    <input type="text" class="input small-input"
           [placeholder]="'home.webcharges.overview.search-paycard' | translate"
           (input)="onPaycardIdFilterChange($event.target.value)"
    >
  </div>
</div>
<ng-container *ngIf="(webcharges$ | async) as webcharges">
  <app-webcharge-overview-table
    class="overview-table"
    [webcharges]="webcharges.content"
    (openDetails)="onOpenDetails($event)"
  ></app-webcharge-overview-table>
  <app-pagination
    [page]="webcharges.number + 1"
    [size]="webcharges.size"
    [totalElements]="webcharges.totalElements"
    (pageSelected)="onPageSelected($event - 1)"
    (sizeSelected)="onSizeSelected($event)"
  ></app-pagination>
</ng-container>

